"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = (e = require("qs")) && "object" == typeof e && "default" in e ? e.default : e,
    r = require("react");

function o(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function s(e, t) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? s(Object(r), !0).forEach(function (t) {
      o(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }

  return e;
}

const i = e => ({
  execute: `/abeet/api/tests/${e}/execute.json`,
  track: `/abeet/api/tests/${e}/track.json`
});

class c {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : i;
    let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    this.urlResolver = t, this.baseUrl = e, this.options = r;
  }

  execute(e, r, o) {
    let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    const i = ((e, r) => {
      const o = t.parse(window.location.search, {
        ignoreQueryPrefix: !0
      }),
            s = n(n({}, r), o.abeet && {
        abeet: {
          [e]: o.abeet[e]
        }
      });
      return t.stringify(s, {
        arrayFormat: "brackets",
        addQueryPrefix: !0
      });
    })(e, n({
      testName: e,
      [r]: o
    }, s)),
          c = this.baseUrl + this.urlResolver(e).execute;

    return fetch(c + i, {
      headers: this.options.headers
    }).then(t => {
      if (!t.ok) throw new Error("Failed to execute text " + e);
      return t.json();
    });
  }

  track(e, t, r, o) {
    const s = this.baseUrl + this.urlResolver(e).track;
    return fetch(s, {
      method: "POST",
      headers: n({
        "Content-Type": "application/json"
      }, this.options.headers),
      body: JSON.stringify(n({
        testName: e,
        [t]: r
      }, o))
    }).then(t => {
      if (!t.ok) throw new Error("Failed to execute text " + e);
    });
  }

}

const u = {
  tests: {},
  track: () => Promise.resolve(),
  execute: () => Promise.resolve(null)
},
      a = r.createContext(u);

function l(e, t) {
  try {
    var r = e();
  } catch (e) {
    return t(e);
  }

  return r && r.then ? r.then(void 0, t) : r;
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

class h extends r.Component {
  constructor(e) {
    super(e), this.client = new c(e.baseUrl, e.urlResolver, e.options), this.state = {
      contextValue: {
        execute: this.execute.bind(this),
        track: this.track.bind(this),
        tests: e.initialTestResults || {}
      }
    };
  }

  render() {
    return this.context.execute !== u.execute ? this.props.children : r.createElement(a.Provider, {
      value: this.state.contextValue
    }, this.props.children);
  }

  componentDidMount() {
    const {
      onResult: e,
      initialTestResults: t
    } = this.props;
    t && e && Object.entries(t).forEach(_ref => {
      let [t, r] = _ref;
      return e(t, r);
    });
  }

  track(e, t, r, o) {
    try {
      const s = this,
            n = l(function () {
        const {
          kind: n,
          name: i,
          metadata: c
        } = o;
        return Promise.resolve(s.client.track(e, t, r, {
          kind: n,
          name: i,
          ts: Date.now().toString(),
          metadata: c
        })).then(function () {});
      }, function () {});
      return Promise.resolve(n && n.then ? n.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }

  execute(e, t, r) {
    let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const s = this;
    return Promise.resolve(l(function () {
      return Promise.resolve(s.getResult(e, t, r, o)).then(function (t) {
        return s.setState(_ref2 => {
          let {
            contextValue: r
          } = _ref2;
          return {
            contextValue: n(n({}, r), {}, {
              tests: n(n({}, r.tests), {}, {
                [e]: t
              })
            })
          };
        }), t;
      });
    }, function () {
      return null;
    }));
  }

  getResult(e, t, r, o) {
    try {
      const s = this;
      return void 0 === s.state.contextValue.tests[e] || o.forceExecute ? Promise.resolve(s.client.execute(e, t, r, o.defaults)).then(function (_ref3) {
        let {
          variables: t
        } = _ref3;
        var r, o;
        return null === (r = (o = s.props).onResult) || void 0 === r || r.call(o, e, t), t;
      }) : Promise.resolve(s.state.contextValue.tests[e]);
    } catch (e) {
      return Promise.reject(e);
    }
  }

}

h.contextType = a, exports.AbeetProvider = h, exports.booleanResultResolver = function (e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "true";
  return r => Boolean(r && r[e] === t);
}, exports.default = c, exports.initialContext = u, exports.useAbeetContext = () => r.useContext(a), exports.useAbeetResult = function (e) {
  let {
    resolver: t
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    tests: o
  } = r.useContext(a);
  return t ? t(o[e]) : o[e];
}, exports.useAbeetTest = function (e, t, o) {
  let {
    resolver: s,
    skip: n
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    skip: !1
  };
  const {
    tests: i,
    execute: c
  } = r.useContext(a),
        [u, l] = r.useState(!(o in i)),
        h = r.useRef(!1);
  r.useEffect(() => {
    h.current || void 0 !== i[o] || !t || n ? l(!1) : (h.current = !0, c(o, e, t).then(() => l(!1)));
  }, [i[o], t, n]);
  const p = n ? null : i[o];
  return [s ? s(p) : p, u];
}, exports.variableResolver = e => t => t ? t[e] : void 0;